package gr.tech.GRAttestation.components.modals

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import gr.tech.GRAttestation.components.inputs.StringInput
import gr.tech.GRAttestation.components.inputs.StringTextArea
import gr.tech.GRAttestation.components.inputs.ValidationTrigger
import gr.tech.GRAttestation.models.storeusers.StoreUsersDTO
import gr.tech.GRAttestation.styles.bsInputLabelStyle
import gr.tech.GRAttestation.styles.bsInputStyle
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H5
import org.jetbrains.compose.web.dom.Text

@Composable
fun StoreUserEditModal(
    storeUser: StoreUsersDTO,
    formError: String = "",
    onClose: () -> Unit,
    onUpdate: (StoreUsersDTO) -> Unit,
) {
    var storeUserMutableCopy by remember { mutableStateOf(storeUser) }
    var newStoreID by remember(storeUser) { mutableStateOf(storeUser.storeId) }

    fun validateForm(): Boolean {
        // TODO need validations

        return true
    }

    Div(attrs = Modifier
        .classNames("card", "d-flex", "flex-column")
        .maxWidth(600.px)
        .fillMaxWidth(90.percent)
        .toAttrs {
            onClick { it.stopPropagation() }
        }
    ) {
        // Fixed Header with Close Button
        Div(attrs = Modifier.classNames("d-flex", "flex-row", "justify-content-between", "p-3", "pb-3").toAttrs()) {
            H5(Modifier.classNames("fw-bold", "m-0").toAttrs()) {
                Text("Edit Store User")
            }

            Button(Modifier.classNames("btn-close").toAttrs {
                onClick { onClose() }
            })
        }

        // Scrollable Content Area
        Div(attrs = Modifier
            .classNames("px-3", "pb-3", "d-flex", "flex-column", "gap-3")
            .maxHeight(70.vh)
            .overflow(Overflow.Hidden, Overflow.Auto)
            .toAttrs()
        ) {
            // Form Error Message
            if (formError.isNotBlank()) {
                Div(attrs = Modifier.classNames("alert", "alert-danger").toAttrs()) {
                    Text(formError)
                }
            }

            // Email Input (Required)
            StringInput(
                direction = FlexDirection.Column,
                justifyContent = JustifyContent.Start,
                alignItems = AlignItems.Start,
                labelModifier = Modifier.bsInputLabelStyle(),
                inputModifier = Modifier.bsInputStyle().classNames("disabled").disabled(true),
                inputId = "StoreUserEmail",
                labelText = "Email",
                value = storeUserMutableCopy.email,
                showError = false,
                minLength = 5,
                maxLength = 128,
                isRequired = true,
                placeholder = "user@example.com",
                validationTrigger = ValidationTrigger.OnChange,
                onValueChange = {
                    //email = it // TODO verify procedure for changing Email address - will require more flows.
                }
            )

            // Rep Name Input (Optional)
            StringInput(
                direction = FlexDirection.Column,
                justifyContent = JustifyContent.Start,
                alignItems = AlignItems.Start,
                labelModifier = Modifier.bsInputLabelStyle(),
                inputModifier = Modifier.bsInputStyle(),
                inputId = "StoreUserFirstName",
                labelText = "First Name",
                value = storeUserMutableCopy.firstName ?: "",
                showError = false,
                minLength = 2,
                maxLength = 128,
                isRequired = false,
                placeholder = "John Doe",
                validationTrigger = ValidationTrigger.OnChange,
                onValueChange = {
                    storeUserMutableCopy = storeUserMutableCopy.copy(
                        firstName = it
                    )
                }
            )

            // Rep Name Input (Optional)
            StringInput(
                direction = FlexDirection.Column,
                justifyContent = JustifyContent.Start,
                alignItems = AlignItems.Start,
                labelModifier = Modifier.bsInputLabelStyle(),
                inputModifier = Modifier.bsInputStyle(),
                inputId = "StoreUserLastName",
                labelText = "Last Name",
                value = storeUserMutableCopy.lastName ?: "",
                showError = false,
                minLength = 2,
                maxLength = 128,
                isRequired = true,
                placeholder = "John Doe",
                validationTrigger = ValidationTrigger.OnChange,
                onValueChange = {
                    storeUserMutableCopy = storeUserMutableCopy.copy(
                        lastName = it
                    )
                }
            )

            // Notes TextArea (Optional)
            StringTextArea(
                direction = FlexDirection.Column,
                justifyContent = JustifyContent.Start,
                alignItems = AlignItems.Start,
                labelModifier = Modifier.bsInputLabelStyle(),
                textAreaModifier = Modifier.bsInputStyle(),
                inputId = "StoreUserNotes",
                labelText = "Notes",
                value = storeUserMutableCopy.notes ?: "",
                hasError = false,
                labelError = "",
                minLength = 0,
                maxLength = 512,
                isRequired = false,
                rows = 4,
                validationTrigger = ValidationTrigger.OnChange,
                onValueChange = {
                    storeUserMutableCopy = storeUserMutableCopy.copy(
                        notes = it
                    )
                }
            )

            // Store Selection
            StorePickerSection(
                lockedStoreId = storeUser.storeId,
                selectedStoreId = newStoreID,
                onStoreSelected = { newStoreID = it }
            )

            // Action Buttons
            Div(attrs = Modifier.classNames("w-100", "mt-3", "gap-2", "d-flex", "flex-row", "justify-content-start", "align-items-center").toAttrs()) {
                Button(
                    attrs = Modifier.classNames("btn", "btn-secondary")
                        .toAttrs {
                            onClick { onClose() }
                        }
                ) {
                    Text("Cancel")
                }

                Spacer()

                Button(
                    attrs = Modifier.classNames("btn", "btn-primary")
                        .toAttrs {
                            onClick {
                                if (validateForm()) {
                                    onUpdate(storeUserMutableCopy.copy(storeId = newStoreID))
                                }
                            }
                        }
                ) {
                    Text("Update User")
                }
            }
        }
    }
}